// extracted by mini-css-extract-plugin
export default {"container":"styles_container__jf3ap","value":"styles_value__76Mjt","answer":"styles_answer__wXyiG"};